import React, { useEffect } from 'react';
import { useThemeStore } from '../store/themeStore';
import { moon } from '../assets/assets';
import { Sun } from 'lucide-react';

const ThemeToggle = ({ className = "" }) => {
  const { isDarkMode, toggleTheme, initializeTheme } = useThemeStore();

  useEffect(() => {
    initializeTheme();
  }, [initializeTheme]);

  return (
    <button 
      onClick={toggleTheme}
      className={`p-2 hover:bg-gray-100 dark:hover:bg-[#32353c] rounded-full transition-colors duration-200 focus:outline-none ${className}`}
      aria-label="Toggle Theme"
    >
      {isDarkMode ? (
        <Sun className="w-5 h-5 text-gray-500 hover:text-gray-300" />
      ) : (
        <img src={moon} alt="Dark Mode" className="w-[18px] h-[18px]" />
      )}
    </button>
  );
};

export default ThemeToggle;
